export { default as Assets } from "./Assets.vue";
export { default as Buildings } from "./Buildings.vue";
export { default as Categories } from "./Categories.vue";
export { default as Error } from "./Error.vue";
export { default as Files } from "./Files.vue";
export { default as Insights } from "./Insights.vue";
export { default as Issues } from "./Issues.vue";
export { default as NoMaterialsLogged } from "./NoMaterialsLogged.vue";
export { default as NoNotifications } from "./NoNotifications.vue";
export { default as NoResults } from "./NoResults.vue";
export { default as NoTimeLogged } from "./NoTimeLogged.vue";
export { default as Spaces } from "./Spaces.vue";
export { default as Tags } from "./Tags.vue";
export { default as Tasks } from "./Tasks.vue";
export { default as UnderConstruction } from "./UnderConstruction.vue";
export { default as Users } from "./Users.vue";

export const types = [
    "Assets",
    "Buildings",
    "Categories",
    "Error",
    "Files",
    "Insights",
    "Issues",
    "NoMaterialsLogged",
    "NoNotifications",
    "NoResults",
    "NoTimeLogged",
    "Spaces",
    "Tags",
    "Tasks",
    "UnderConstruction",
    "Users",
];
